import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import moment from "moment";
import { Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import Loader from "./components/Loader";
import "./global.css";
import GenericAlert from "./layout/Alert";
import Router from "./router";
import store from "./store";
import "./theme/fonts.css";
import getTheme from "./theme/index";

function App() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar" ? "rtl" : "ltr";
  moment.locale(i18n.language);
  document.body.setAttribute("dir", isRTL);

  const theme = useMemo(() => {
    return createTheme({ ...getTheme(isRTL), direction: isRTL });
  }, [isRTL]);

  let plugins = [prefixer];
  if (isRTL === "rtl") {
    plugins.push(rtlPlugin);
  }

  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: plugins,
  });

  return (
    <Suspense fallback={<Loader />}>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box id="app" height={1}>
            <Suspense fallback={<Loader />}>
              <Provider store={store}>
                <BrowserRouter>
                  <Router />
                </BrowserRouter>{" "}
                <GenericAlert />
              </Provider>
            </Suspense>
          </Box>
        </ThemeProvider>
      </CacheProvider>
    </Suspense>
  );
}

export default App;
